/******************************************************************************************
 *	Order Line Item Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.productsWithSameOrderNumberModal', [])
    .factory(
      'ProductsWithSameOrderNumberModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/product-with-same-order-number-modal.html',
          controller: 'ProductsWithSameOrderNumberModalController',
          classNames: 'product-with-same-order-number-modal'
        });
      }
    )
    .controller(
      'ProductsWithSameOrderNumberModalController',
      /* @ngInject */
      function($scope, ProductsWithSameOrderNumberModal) {

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          ProductsWithSameOrderNumberModal.remove({cancelled: true});
        };
      }
    );
})();
